module.exports = __webpack_public_path__ + "img/ic_profile_button.e42e1d53.svg";